import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getChannelPartnerIDByLocation } from '../utils/evergentUtils';
import { ConfigService } from './config.service';
import { LocalStorageService } from './storage/local-storage.service';
import { KEYS } from '../utils/constants/storage.constants';
import { NewrelicService } from 'src/app/analytics/newrelic/services/newrelic.service';
import { useAnimation } from '@angular/animations';

export class RegionAPIResult {
  country!: string;
  countryCode!: string;
  city!: string;
  region?: string;
  group!: string;
}
class LocationAPIResult {
  continent?: string;
  continentName?: string;
  district?: string;
  city?: string;
  country?: string;
  countryName?: string;
  group?: string;
  isp?: string;
  lat?: number;
  lon?: number;
  mobile?: boolean;
  proxy?: boolean;
  region?: string;
  regionName?: string;
  zip?: string;
  timezone?: string;
  hosting?: string;
  data: any;
}

@Injectable({
  providedIn: 'root',
})
export class GeoLocationService {
  allowedRegions = '';

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
    private readonly localStorage: LocalStorageService,
    private readonly newrelicService: NewrelicService
  ) {}

  getChannel(location: RegionAPIResult): string {
    const channel = JSON.parse(
      atob(this.configService.applicationConfig.evBUChannelList)
    );
    const channelData = channel.filter(
      (element: any) => element.group === location.group.toLowerCase()
    );
    return channelData && channelData.length > 0
      ? channelData[0].evChannelName
      : 'AHA_ROW';
  }

  getCountryCode(): string {
    const location: RegionAPIResult = localStorage.getItem(KEYS.LOCATION)
      ? JSON.parse(this.localStorage.getItem(KEYS.LOCATION) || '{}')
      : null;
    if (location) {
      const region = location?.countryCode?.toLowerCase();
      return region;
    }
    return 'all';
  }

  getRegion(): string {
    try {
      const location: RegionAPIResult = localStorage?.getItem(KEYS.LOCATION)
        ? JSON.parse(this.localStorage?.getItem(KEYS.LOCATION) || '{}')
        : null;
      if (location && location.group) {
        const region = location.group.toUpperCase();
        const evergentRegions = JSON.parse(
          atob(this.configService.applicationConfig.evBUChannelList)
        );
        return evergentRegions.find(
          (item: any) => item?.group?.toUpperCase() === region?.toUpperCase()
        )
          ? region?.toLowerCase()
          : 'in';
      }
      return 'in';
    } catch (e) {
      return 'in';
    }
  }

  public async getGeolocation(): Promise<RegionAPIResult> {
    const appConfig = this.configService.applicationConfig;
    const url = `${appConfig.geoLocationURL}/device/location/lookup`;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const KEY_AUTHORIZATION = 'Authorization';
    const KEY_CONTENT_TYPE = 'content-type';
    const headers = new HttpHeaders({
      [KEY_AUTHORIZATION]: `Bearer ${this.localStorage.getItem(
        KEYS.PLATFORM_TOKEN
      )}`,
      [KEY_CONTENT_TYPE]: 'application/json',
    });
    try {
      const response = await this.http
        .get<LocationAPIResult>(url, { headers })
        .toPromise()
        .then((test) => test?.data);
      this.localStorage.setItem(KEYS.LOCATION, JSON.stringify(response));
      this.localStorage.setItem(KEYS.CITY, response.city);
      this.localStorage.setItem(KEYS.REGION, response.region);
      this.configService.applicationConfig.channelPartnerID =
        getChannelPartnerIDByLocation(this.configService.applicationConfig);
      return Promise.resolve(response);
    } catch (error) {
      this.newrelicService.sendErrorEvent({
        error,
      });
      return Promise.resolve(null);
    }
  }

  isFromIndia = (): boolean =>
    this.localStorage.getItem(KEYS.LOCATION) &&
    JSON.parse(
      this.localStorage.getItem(KEYS.LOCATION)
    ).country.toUpperCase() === 'IN';

  isChannelPartnerValid = (): boolean => {
    const channelPartnerID = getChannelPartnerIDByLocation(
      this.configService.applicationConfig
    );
    return (
      channelPartnerID === this.configService.applicationConfig.channelPartnerID
    );
  };
}
